import _defineProperty from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { intlMessageShape, linkShape } from '@jutro/prop-types';
import { PopoverContainer } from '../PopoverContainer/PopoverContainer';
import styles from "./NotificationAction.module.css";
import { Popover, availableAlignments } from '../Popover/Popover';
var notificationActionPropTypes = {
  id: PropTypes.string.isRequired,
  title: intlMessageShape,
  headerLink: linkShape,
  footerLink: linkShape,
  className: PropTypes.string,
  children: PropTypes.node,
  renderTrigger: PropTypes.func.isRequired,
  align: PropTypes.oneOf(availableAlignments),
  isFlipEnabled: PropTypes.bool
};
export var NotificationAction = function NotificationAction(_ref) {
  var id = _ref.id,
      renderTrigger = _ref.renderTrigger,
      align = _ref.align,
      isFlipEnabled = _ref.isFlipEnabled,
      popoverProps = _objectWithoutProperties(_ref, ["id", "renderTrigger", "align", "isFlipEnabled"]);

  return React.createElement(Popover, {
    id: id,
    renderTrigger: renderTrigger,
    align: align,
    className: styles.popper,
    isFlipEnabled: isFlipEnabled
  }, React.createElement(PopoverContainer, _objectSpread({
    className: styles.popoverContainer,
    internalClassNames: {
      title: styles.popoverTitle,
      headerLink: styles.popoverHeaderLink,
      body: styles.popoverBody,
      footerLink: styles.popoverFooterLink
    }
  }, popoverProps)));
};
NotificationAction.propTypes = notificationActionPropTypes;
NotificationAction.defaultProps = _objectSpread({}, Popover.defaultProps);
NotificationAction.__docgenInfo = {
  componentName: "NotificationAction",
  packageName: "@jutro/components",
  description: "NotificationAction",
  displayName: "NotificationAction",
  methods: [],
  actualName: "NotificationAction",
  metadataType: "action",
  props: {
    id: {
      type: {
        name: "string"
      },
      required: true,
      description: "Used to identify this component."
    },
    title: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "shape",
          value: {
            id: {
              name: "string",
              required: false
            },
            defaultMessage: {
              name: "string",
              required: false
            },
            args: {
              name: "shape",
              value: {},
              required: false
            }
          }
        }]
      },
      required: false,
      description: "Notification popover title"
    },
    headerLink: {
      type: {
        name: "shape",
        value: {
          label: {
            name: "custom",
            raw: "intlMessageShape.isRequired",
            required: true
          },
          onClick: {
            name: "func",
            required: false
          },
          href: {
            name: "custom",
            raw: "intlMessageShape",
            required: false
          }
        }
      },
      required: false,
      description: "Description for header link"
    },
    footerLink: {
      type: {
        name: "shape",
        value: {
          label: {
            name: "custom",
            raw: "intlMessageShape.isRequired",
            required: true
          },
          onClick: {
            name: "func",
            required: false
          },
          href: {
            name: "custom",
            raw: "intlMessageShape",
            required: false
          }
        }
      },
      required: false,
      description: "Description for footer link"
    },
    className: {
      type: {
        name: "string"
      },
      required: false,
      description: "CSS class name for this component"
    },
    children: {
      type: {
        name: "node"
      },
      required: false,
      description: "Notification popover content"
    },
    renderTrigger: {
      type: {
        name: "func"
      },
      required: true,
      description: "Function to render trigger element"
    },
    align: {
      type: {
        name: "enum",
        computed: true,
        value: "availableAlignments"
      },
      required: false,
      description: "Popover alignment (relative to trigger element)"
    },
    isFlipEnabled: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Should popover flip when it is about to overflow the visible area"
    }
  }
};